
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import Layout from "components/Layout";
import { getGlobals } from "lib/getGlobals";
import Meta from "components/Meta";
import useTranslation from "next-translate/useTranslation";
import Header from "components/Header";
import Link from "next/link";

export default function SitemapPage({ globals }) {
  const { t } = useTranslation("common");

  const crumbs = [
    {
      path: "home.path",
      title: "home.title",
      translate: true,
    },
    {
      title: "sitemap.title",
      translate: true,
    },
  ];

  return (
    <Layout
      globals={globals}
      header={<Header crumbs={crumbs} title={t("sitemap.title")} />}
    >
      <Meta title={t("sitemap.title")} description={t("sitemap.description")} />

      <section className="relative pt-16 pb-24">
        <div className="relative container px-4 mx-auto">
          <div className="prose prose-white max-w-none">
            {globals?.menus?.main.length > 0 && (
              <>
                <h2 className="mb-8 text-2xl font-serif font-bold">
                  {t("sitemap.menus.main")}
                </h2>
                <ul>
                  {globals.menus.main.map((item) => {
                    const hasChilds = item.items && item.items.length > 0;
                    return (
                      <li key={item.id}>
                        <Link href={item.url} passHref>
                          <a>{item.title}</a>
                        </Link>
                        {hasChilds && (
                          <ul>
                            {item.items.map((subItem) => {
                              return (
                                <li key={subItem.id}>
                                  <Link href={subItem.url} passHref>
                                    <a>{subItem.title}</a>
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </>
            )}

            {globals?.menus?.footer.length > 0 && (
              <>
                <h2 className="mb-8 text-2xl font-serif font-bold">
                  {t("sitemap.menus.footer")}
                </h2>
                <ul>
                  {globals.menus.footer.map((item) => {
                    const hasChilds = item.items && item.items.length > 0;
                    return (
                      <li key={item.id}>
                        <Link href={item.url} passHref>
                          <a>{item.title}</a>
                        </Link>
                        {hasChilds && (
                          <ul>
                            {item.items.map((subItem) => {
                              return (
                                <li key={subItem.id}>
                                  <Link href={subItem.url} passHref>
                                    <a>{subItem.title}</a>
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
}

 async function _getStaticProps(context) {
  return {
    props: {
      globals: await getGlobals(context),
    },
    revalidate: 30,
  };
}


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/sitemap',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  